import React from 'react';
import RedesignedMentionsPing from './redesigned_mentions_ping';
import routes from 'js/core_pre_webpack/routes';
import { commaize, keptAlivePost } from 'js/utils';
import indefinite from 'indefinite';
import Modal from 'js/components/modals/Modal';
import $image_url from '../../utils/image_url';
import styled from 'astroturf/react';
import { Props as OnsitePingProps } from 'js/onsite_pings/react/onsite_ping';
import _AnchorContainer from "mentions_milestone_ping-AnchorContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=AnchorContainer";
import _Anchor from "mentions_milestone_ping-Anchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=Anchor";
import _Takeover from "mentions_milestone_ping-Takeover.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=Takeover";
import _TakeoverImage from "mentions_milestone_ping-TakeoverImage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=TakeoverImage";
import _CtaColumn from "mentions_milestone_ping-CtaColumn.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=CtaColumn";
import _NoThanksButton from "mentions_milestone_ping-NoThanksButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/mentions_milestone_ping.tsx?styleId=NoThanksButton";


const AnchorContainer = /*#__PURE__*/styled("div", null, {
  displayName: "AnchorContainer",
  styles: _AnchorContainer
});

const Anchor = /*#__PURE__*/styled("a", null, {
  displayName: "Anchor",
  styles: _Anchor
});

const Takeover = /*#__PURE__*/styled("div", null, {
  displayName: "Takeover",
  styles: _Takeover
});

const TakeoverImage = /*#__PURE__*/styled("img", null, {
  displayName: "TakeoverImage",
  styles: _TakeoverImage
});

const CtaColumn = /*#__PURE__*/styled("div", null, {
  displayName: "CtaColumn",
  styles: _CtaColumn
});

const NoThanksButton = /*#__PURE__*/styled("button", null, {
  displayName: "NoThanksButton",
  styles: _NoThanksButton
});

interface Props extends OnsitePingProps {
  mentionedName: string;
  researchInterestName: string;
  type: string;
  mentionsMilestoneOrdinal: string;
  mentionsMilestone: number;
  userFirstName: string;
}

type State = {
  open: boolean;
};

class MentionsMilestonePing extends RedesignedMentionsPing<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  render() {
    if (!this.state.open) {
      return null;
    } else {
      return this.renderTakeoverPing();
    }
  }

  renderTakeoverPing() {
    return (
      <Modal onClose={() => this.dismissPing()}>
        <Takeover>
          <TakeoverImage
            src={$image_url('page_celebration_quote.svg')}
            alt="Academia Premium"
          />
          <h1>{this.getSubjectText()}</h1>
          <p>{this.getBody()}</p>
          <CtaColumn>
            {this.renderButton()}
            <NoThanksButton onClick={() => this.dismissPing()}>
              No Thanks
            </NoThanksButton>
          </CtaColumn>
        </Takeover>
      </Modal>
    );
  }

  dismissPing(): void {
    this.setState({ open: false });
    this.recordDismissal();
  }

  recordDismissal(): void {
    const url = routes.record_ping_dismissal_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  getBody() {
    return this.props.type === 'paper'
      ? this.getPaperText()
      : this.getAuthorText();
  }

  getPaperText() {
    const { researchInterestName, mentionedName } = this.props;
    const article = indefinite(researchInterestName, { articleOnly: true });

    return (
      <div className="text">
        The name <strong>{mentionedName}</strong> is mentioned in {article}{' '}
        <strong>{researchInterestName}</strong> paper uploaded to Academia.
      </div>
    );
  }

  getAuthorText() {
    const { researchInterestName, mentionedName } = this.props;
    const article = indefinite(researchInterestName, { articleOnly: true });

    return (
      <div className="text">
        The name <strong>{mentionedName}</strong> is mentioned by {article}{' '}
        <strong>{researchInterestName}</strong> researcher in a paper uploaded
        to Academia.
      </div>
    );
  }

  renderButton() {
    return (
      <AnchorContainer>
        <Anchor
          href={this.getUpgradeURL()}
          onClick={() => this.recordClickthrough()}
        >
          {this.getButtonText()}
        </Anchor>
      </AnchorContainer>
    );
  }

  getUpgradeURL() {
    return routes.upgrade_url({
      feature: 'searchm',
      trigger: 'mentions-view-download-milestone-onsite-ping',
      after_upgrade_path: encodeURIComponent(routes.mentions_path()),
    });
  }

  recordClickthrough(): void {
    const url = routes.record_ping_clickthrough_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  getSubjectText() {
    const { mentionsMilestone, mentionsMilestoneOrdinal, userFirstName } =
      this.props;
    // Convert to 1,234th
    const mentionsCount = `${commaize(
      mentionsMilestone,
    )}${mentionsMilestoneOrdinal}`;
    return `Congratulations on your ${mentionsCount} mention, ${userFirstName}!`;
  }

  getButtonText() {
    return 'View Your Mentions ▸';
  }

  renderUserInfo() {
    return (
      <div className="user-info">
        <div className="celebratory-title">
          <div>{this.getSubjectText()}</div>
        </div>
      </div>
    );
  }
}

export default MentionsMilestonePing;
